<template>
<div class="chapter">
<div class="inner_page">
<div class="chap" id="ded">
<p class="ct"><a class="xref" href="#/OEBPS/pppmaddog006#maintoc">Dedication</a></p>
<p class="ded"><em class="calibre5">For Barbara,</em><br class="calibre1"/><em class="calibre5">and for the fearsome Partridge Quails of ’62</em><br class="calibre1"/><em class="calibre5">when we were young and the earth was verifiably flat</em><br class="calibre1"/><em class="calibre5">and all the universe orbited around Kansas.</em></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ppp-maddog004.vue?750fec0a